export const parseDate = (dateString: string) =>
  dateString ? new Date(dateString) : null;
